////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
/////////ASSETS/////////
import Actif from '../../../assets/icones/global/actif-item.svg'

//////STYLED//////
const StatusWrapper = styled.div`
	max-height: auto;
	max-width: auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
`

const AddItemCatalogPicto = styled.img`
	max-height: 20px;
	max-width: 20px;
	margin-right: 5px;
`
//////STYLED//////

const AddItemCatalogStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<StatusWrapper>
			<AddItemCatalogPicto src={props.row.itemDistributorPresent ? Actif : ''} />
		</StatusWrapper>
	)
}

AddItemCatalogStatus.propTypes = {}

AddItemCatalogStatus.defaultPropTypes = {}

export default AddItemCatalogStatus
